import { LessonPin } from '@lessonup/teaching-core';
import { Checkbox, PinThumbBottomBar, InfoSvg, PinView } from '@lessonup/typescript-core/ui';
import classNames from 'classnames';
import React from 'react';

interface PinResultProps {
  pin: LessonPin;
  selected: boolean;
  toggleSelectPin: (pin: string) => void;
  openPinInfo?: (pinId: string) => void;
  pinSize?: 250 | 350 | 400;
  highlighted?: boolean;
  onClick?: (pinId: string) => void;
}

export const PinResult: React.FunctionComponent<PinResultProps> = ({
  pin,
  selected,
  toggleSelectPin,
  openPinInfo,
  pinSize,
  highlighted,
  onClick,
}: PinResultProps) => {
  const handlePinInfoClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!openPinInfo) return;
    event.stopPropagation();
    openPinInfo(pin._id);
  };
  const handlePinClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!onClick) return;
    event.stopPropagation();
    onClick(pin._id);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
    <div className={classNames('pin-result', { highlighted: !!highlighted })} key={pin._id} onClick={handlePinClick}>
      <div className={`pin-size-${pinSize || 400}`}>
        <PinView pin={pin} isThumb={true} />

        <PinThumbBottomBar>
          <Checkbox
            id={`pin-result-checkbox-${pin._id}`}
            checked={selected}
            onChange={() => toggleSelectPin(pin._id)}
            theme="secondary"
            height="large"
            stopPropagation={true}
          />
          {openPinInfo && (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
            <div className="pin-result-info" onClick={handlePinInfoClick}>
              <InfoSvg />
            </div>
          )}
        </PinThumbBottomBar>
      </div>
    </div>
  );
};
